import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonButton,
  IonBackButton,
  isPlatform,
  IonIcon,
} from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
import { RouteComponentProps, withRouter } from "react-router";

import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";

// CSS
import "./HelpCentreDetailPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import disclosureRight from "../../assets/Button_Disclosure_Right_Blue@3x.png";
import iconPlay from "../../assets/Button_Video_Play@3x.png";

import onboardingImageDash from "../../assets/Image_OB_v2Dash@3x.png";
import onboardingImageSearching from "../../assets/Image_OB_Searching@3x.png";
import onboardingImageSpeakContent from "../../assets/Image_OB_SpeakContent@3x.png";
import onboardingImageGuidelineUpdates from "../../assets/Image_OB_GuidelineUpdates@3x.png";
import onboardingImagePins from "../../assets/Image_OB_Pins@3x.png";
import onboardingImageParaPassLink from "../../assets/Image_OB_ParaPassLink@3x.png";
import onboardingImageEditDash from "../../assets/Image_OB_EditDash@3x.png";
import onboardingImageSearchFilter from "../../assets/Image_OB_SearchFilter@3x.png";
import onboardingImagePageSearch from "../../assets/Image_OB_PageSearch@3x.png";

// Controllers
import { IHelpCentreItem, IScreenProps, IUser } from "../../Interfaces";
import RemoteDataController from "../../controllers/RemoteDataController";

// Components

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  helpCentreItem: IHelpCentreItem | undefined;
};

class HelpCentreDetailPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    let selectedID = "";
    if (props.match.url != null) {
      selectedID = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);
    }
    if (selectedID == null) {
      selectedID = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);
    }

    let helpCenterItem = this.props.screenProps.helpCentreItems.find(
      (helpCenterItem) => helpCenterItem.id === selectedID
    );

    this.state = {
      helpCentreItem: helpCenterItem,
    };
  }

  async componentDidMount() {
    if (this.state.helpCentreItem != null) {
      RemoteDataController.logEvent("help_centre_page_viewed", {
        help_page_viewed: this.state.helpCentreItem.title,
      });
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if (prevProps.screenProps.helpCentreItems != this.props.screenProps.helpCentreItems) {
      let selectedID = "";
      if (this.props.match.url != null) {
        selectedID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
      }
      if (selectedID == null) {
        selectedID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
      }

      let helpCentreItem = this.props.screenProps.helpCentreItems.find(
        (helpCentreItem) => helpCentreItem.id === selectedID
      );

      if (helpCentreItem != null) {
        this.setState({ helpCentreItem });
      }
    }
  }

  openClassLink(helpCentreItem: IHelpCentreItem | null) {
    if (helpCentreItem != null && helpCentreItem.classUrl != null && helpCentreItem.classUrl !== "") {
      Browser.open({ url: helpCentreItem.classUrl });
    } else {
      Browser.open({ url: "https://www.classprofessional.co.uk/faqs#jrcalc-plus-app" });
    }
  }

  render() {
    let helpCentreItem = this.state.helpCentreItem;
    let contentLayout = null;

    if (helpCentreItem != null) {
      let showVideo = helpCentreItem.videoID != null && helpCentreItem.videoID !== "";

      // show current item
      let imageVideoLayout = null;

      if (showVideo) {
        let videoID = helpCentreItem.videoID;
        let videoSrc =
          `https://player.vimeo.com/video/` + videoID + `${videoID.includes("?") ? "&" : "?"}?portrait=0&autoplay=1`;

        imageVideoLayout = (
          <div className="helpCentreVideoContainer globalContentMargin">
            <iframe src={videoSrc} className="helpCentreVideoFrame" allowFullScreen></iframe>
          </div>
        );
      } else if (helpCentreItem.imageFileName && helpCentreItem.imageFileName !== "") {
        let imageSrc = "";

        if (helpCentreItem.imageFileName !== "") {
          let image = this.props.screenProps.images.find(
            (image) => helpCentreItem != null && image.name === helpCentreItem.imageFileName
          );
          if (image != null) {
            imageSrc = image.data;
          }
        }

        // load bundled images if latest images haven't been downloaded yet
        if (imageSrc == null || imageSrc == "") {
          if (helpCentreItem.imageFileName === "Image_OB_v2Dash@3x.png") {
            imageSrc = onboardingImageDash;
          } else if (helpCentreItem.imageFileName === "Image_OB_Searching@3x.png") {
            imageSrc = onboardingImageSearching;
          } else if (helpCentreItem.imageFileName === "Image_OB_SpeakContent@3x.png") {
            imageSrc = onboardingImageSpeakContent;
          } else if (helpCentreItem.imageFileName === "Image_OB_GuidelineUpdates@3x.png") {
            imageSrc = onboardingImageGuidelineUpdates;
          } else if (helpCentreItem.imageFileName === "Image_OB_Pins@3x.png") {
            imageSrc = onboardingImagePins;
          } else if (helpCentreItem.imageFileName === "Image_OB_ParaPassLink@3x.png") {
            imageSrc = onboardingImageParaPassLink;
          } else if (helpCentreItem.imageFileName === "Image_OB_EditDash@3x.png") {
            imageSrc = onboardingImageEditDash;
          } else if (helpCentreItem.imageFileName === "Image_OB_SearchFilter@3x.png") {
            imageSrc = onboardingImageSearchFilter;
          } else if (helpCentreItem.imageFileName === "Image_OB_PageSearch@3x.png") {
            imageSrc = onboardingImagePageSearch;
          }
        }

        if (showVideo === false) {
          imageVideoLayout = (
            <div className="helpCentreImageContainer globalContentMargin">
              <img className="helpCentreImage" src={imageSrc} />
            </div>
          );
        }
      }

      contentLayout = (
        <div className="">
          <div className="globalContentMargin helpCentreTitle">{helpCentreItem.title}</div>
          {imageVideoLayout}
          <div className="globalContentMargin helpCentreBottomContent">
            <div className="helpCentreDescription" dangerouslySetInnerHTML={{ __html: helpCentreItem.html }} />
            <div>
              Didn't get the answer you needed?{" "}
              <span
                className="helpCentreContactSupportLink"
                onClick={this.props.screenProps.sendSupportEmail.bind(this, "Subscription Support")}
              >
                Contact support
              </span>
            </div>
          </div>
        </div>
      );
    } else {
      let message = "Page Loading";
      if (this.props.screenProps.messageBarText == "") {
        message = "Page couldn't be loaded. It might not exist or has been removed.";
      }

      contentLayout = (
        <div className="emptyPageContainer">
          <div className="emptyPageText">{message}</div>
        </div>
      );
    }

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonTitle>Help Centre</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen className="helpCentrePageContent">
          {contentLayout}
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(HelpCentreDetailPage);
